import React, { ChangeEvent, useState } from 'react';
import * as R from 'ramda';

import { Button, Icon, IconButton, Modal } from '@atom/mui';
import colors from '@atom/styles/colors';
import { MediaItem } from '@atom/types/media';

import FhwaMediaTile from './FhwaMediaTile';

import classes from '../formInstance.module.css';

const styles = {
  icon: {
    padding: '0px',
    height: '24px',
    width: '24px',
  },
};

interface Props {
  isUploadDisabled: boolean;
  isEditable: boolean;
  media: MediaItem[];
  assetId: string;
  assetFileUpload: (event: ChangeEvent<HTMLInputElement>) => void;
  removeFile: (mediaId: string, subjectId: string) => void;
  renameMedia: (mediaId: string, subjectId: string, name: string) => void;
}

const FhwaMediaModal = ({
  assetId,
  assetFileUpload,
  media,
  removeFile,
  renameMedia,
  isEditable,
  isUploadDisabled,
}: Props) => {
  const [open, setOpen] = useState(false);
  const closeModal = () => setOpen(false);
  const openModal = () => setOpen(true);

  const mediaCount = R.length(media);
  const photosIconColor = !R.isEmpty(media)
    ? colors.brand.blue
    : colors.neutral.silver;

  const footerButtons = (
    <>
      {isEditable && !isUploadDisabled && (
        <Button component="label" color="primary">
          Upload Photo
          <input type="file" hidden multiple onChange={assetFileUpload} />
        </Button>
      )}

      <Button onClick={closeModal} variant="contained" color="primary">
        Done
      </Button>
    </>
  );

  return (
    <React.Fragment>
      <IconButton style={styles.icon} onClick={openModal}>
        <Icon color={photosIconColor}>photo</Icon>
      </IconButton>
      <div className={classes.columnSuffixText}>{mediaCount}</div>
      <Modal
        title="Photos"
        open={open}
        footer={footerButtons}
        onCancel={closeModal}
      >
        <div className={classes.fhwaPhotoModalContent}>
          {media.map((medium: MediaItem) => (
            <FhwaMediaTile
              key={medium.id}
              media={medium}
              assetId={assetId}
              removeFile={removeFile}
              renameMedia={renameMedia}
            />
          ))}
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default FhwaMediaModal;
